// extracted by mini-css-extract-plugin
export default {"section":"addons_section__oa4LD","mainSection":"addons_mainSection__KAj7H"};